@if (content.cards) {
  <div
    class="skyclub-tracker"
    role="region"
    aria-label="Sky Club spend tracker"
  >
    <!--[attr.data-cy]="content.header.split(' ').join('').toLowerCase()"-->
    <div
      class="skyclub-tracker__header"
      role="banner"
      [attr.aria-label]="content.headerLogo.alt"
    >
      <span
        class="skyclub-tracker__header__logo"
        role="img"
        data-cy="skyclub-spend-tracker-header-logo"
      >
        <img [src]="content.headerLogo.src" [alt]="content.headerLogo.alt" />
      </span>

      @if (content.cards.length > 1) {
        <nav
          class="skyclub-tracker__header__navigation"
          role="navigation"
          aria-label="Card navigation"
        >
          <button
            class="skyclub-tracker__header__navigation__previous"
            [ngClass]="{
              'skyclub-tracker__header__navigation__previous--disabled':
                carouselIndex === 0
            }"
            [attr.tabindex]="carouselIndex === 0 ? -1 : 0"
            [attr.aria-disabled]="carouselIndex === 0"
            (click)="previous()"
            role="button"
            [attr.aria-label]="
              'Previous card, currently showing card ' +
              (carouselIndex + 1) +
              ' of ' +
              content.cards.length
            "
            data-cy="skyclub-spend-tracker-previous_action_button"
          ></button>
          <button
            class="skyclub-tracker__header__navigation__next"
            [ngClass]="{
              'skyclub-tracker__header__navigation__next--disabled':
                carouselIndex === content.cards.length - 1
            }"
            [attr.tabindex]="
              carouselIndex === content.cards.length - 1 ? -1 : 0
            "
            [attr.aria-disabled]="carouselIndex === content.cards.length - 1"
            (click)="next()"
            role="button"
            [attr.aria-label]="
              'Next card, currently showing card ' +
              (carouselIndex + 1) +
              ' of ' +
              content.cards.length
            "
            data-cy="skyclub-spend-tracker-next_action_button"
          ></button>
        </nav>
      }
    </div>

    <!-- Cards -->
    <div
      class="skyclub-tracker__carousel {{
        content.cards[carouselIndex] &&
        content.cards[carouselIndex].thresholdMet
          ? 'threshold-met'
          : ''
      }}"
      role="main"
      [attr.aria-label]="
        'Sky Club card ' + (carouselIndex + 1) + ' of ' + content.cards.length
      "
    >
      <div class="skyclub-tracker__carousel__wrapper">
        @if (content.cards.length > 0) {
          <div
            class="skyclub-tracker__carousel__cards"
            role="tabpanel"
            [attr.aria-labelledby]="'card-' + carouselIndex"
          >
            <idp-skyclub-spend-tracker-card
              [content]="content.cards"
              [carouselIndex]="carouselIndex"
              (skyclubTrackerClick)="skyclubTrackerClick.emit($event)"
            ></idp-skyclub-spend-tracker-card>
          </div>
        }
      </div>
    </div>
  </div>
}
